<template>
    <div class="component-container">
        <div class="swiper-button-prev">
            <v-icon color="white" size="40">chevron_left</v-icon>
        </div>
        <div class="swiper-container">
            <div class="swiper-wrapper">
                <div v-for="(item, index) in data" :key="index" class="swiper-slide">
                    <slot :item="item" :index="index" />
                </div>
            </div>
        </div>
        <div class="swiper-button-next">
            <v-icon color="white" size="40">chevron_right</v-icon>
        </div>
    </div>
</template>

<script>
  import Swiper from 'swiper/bundle'
  export default {
    name: 'MSwiper',
    props: { data: { type: Array, required: true }, focusedItem: Number },
    data: () => ({
      swiper: null
    }),
    watch: {
      data () {
        this.$nextTick(function () {
          this.initPlugin()
        })
      },
      // Essa conta serve para descobrir qual o número da página dado a quantidade de itens por páginas e a posição do item
      focusedItem (index) {
        const slides_per_view = this.swiper.params.slidesPerView
        const indexToSlide = Math.ceil((index + 1) / slides_per_view) - 1
        this.swiper.slideTo(indexToSlide)
      }
    },
    mounted () {
      this.initPlugin()
    },
    methods: {
      initPlugin () {
        if (this.swiper) {
          this.swiper.destroy()
        }
        this.swiper = new Swiper('.swiper-container', {
          slidesPerView: 1,
          spaceBetween: 0,
          breakpoints: {
            600: { slidesPerView: 2 },
            1264: { slidesPerView: 3 }
          },
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
          }
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
    .component-container {
        position: relative;
        padding: 0 35px;
    }
    .swiper-button-prev, .swiper-button-next {
        color: #FFFFFF;
        background: var(--primary);
        width: 30px;
        height: 30px;
        border-radius: 50%;
        &:after {
            content: ''
        }
    }
    .swiper-button-prev {
        left: 0;
    }
    .swiper-button-next {
        right: 0;
    }
</style>
